import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        prefixs: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        prefixMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getPrefixsRequest({dispatch}) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receivePrefixs", null);
            } else {
                dispatch("receivingPrefixs"); // สถานะ กำลังบันทึก

                axios.get('/prefixs').then(res => {

                    dispatch("receivePrefixs", res.data);
                })
                    .catch((e) => {
                        console.log(e);
                        dispatch("receivePrefixs", null);
                    })
            }
        },
        loadPrefixRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receivePrefix", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingPrefix");
                axios.get('/prefixs/' + id).then(res => {
                    dispatch("receivePrefix", res.data);
                })
            }
        },
        updatePrefixRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingPrefix");
            axios.put('/prefixs/' + payload.prefix_code, payload).then(res => {
                dispatch("updatePrefix", res.data);
            })
        },
        createPrefixRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingPrefix");
            axios.post('/prefixs', payload).then(res => {
                dispatch("receivePrefix", res.data);
            })
        },
        deletePrefixRequest({dispatch}, payload) {

            dispatch("afterDeletePrefix", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingPrefix", payload);

            axios.post('/delete_prefixs', payload).then(res => {
                dispatch("deletePrefix", {prefix_code: payload.prefix_code, res: res});
            })


        },
        receivePrefixs({commit}, payload) {
            commit("RECEIVED_PREFIXS", payload)
        },
        receivingPrefixs({commit}) {
            commit("RECEIVING_PREFIXS") //call matutions --> state.isReceiving = true;
        },
        receivePrefix({commit}, payload) {
            commit("RECEIVED_PREFIX", payload)
        },
        receivingPrefix({commit}) {
            commit("RECEIVING_PREFIXS") //call matutions --> state.isReceiving = true;
        },
        updatePrefix({commit}, payload) {
            commit("UPDATED_PREFIX", payload)
        },
        updatingPrefix({commit}) {
            commit("UPDATING_PREFIX") //  call matutions --> state.isUpdating = true;
        },
        deletePrefix({commit}, payload) {
            commit("DELETED_PREFIX", payload)
        },
        deletingPrefix({commit}, payload) {
            commit("DELETING_PREFIX", payload)
        },
        afterDeletePrefix({commit}, payload) {
            commit("AFFTER_DELETED_PREFIX", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_PREFIXS(state, payload) {
            state.prefixs = payload;
            state.isReceiving = false;

        },
        RECEIVING_PREFIXS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_PREFIX(state, payload) {


            if (payload.prefix_code == undefined) {
                let error = !payload.e.errorInfo==true?payload.message:payload.e.errorInfo.toString()
                let prefixMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    prefixMessage: (state.prefixMessage == prefixMessage ? prefixMessage + ' ' : prefixMessage),

                });
            } else {
                let prefixMessage = 'บันทึกสำเร็จ! รายการ ' + payload.prefix_code + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    prefixs: [...state.prefixs, payload],
                    isReceiving: false,
                    errorMessage: false,
                    prefixMessage: (state.prefixMessage == prefixMessage ? prefixMessage + ' ' : prefixMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_PREFIX(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_PREFIX(state, payload) {
            let index = state.prefixs.findIndex(p => p.prefix_code === payload.prefix_code);
            let prefixMessage = 'บันทึกสำเร็จ! รายการ ' + payload.prefix_code + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                prefixs: state.prefixs.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                prefixMessage: (state.prefixMessage == prefixMessage ? prefixMessage + ' ' : prefixMessage),
            })
        },
        UPDATING_PREFIX(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_PREFIX(state, payload) {

            console.log('delete')

            if (payload.prefix_code == undefined || payload.res.data.message == 'Relation') {
                let prefixMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.prefix_code;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    prefixMessage: (state.prefixMessage == prefixMessage ? prefixMessage + ' ' : prefixMessage),

                });
            } else {
                let indexToDelete = state.prefixs.findIndex(p => p.prefix_code === payload.prefix_code);
                let prefixs = [...state.prefixs];
                prefixs.splice(indexToDelete, 1);
                let prefixMessage = 'บันทึกสำเร็จ! รายการ ' + payload.prefix_code + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    prefixs: [...prefixs],
                    isDeleting: false,
                    idToDelete: null,
                    prefixMessage: (state.prefixMessage == prefixMessage ? prefixMessage + ' ' : prefixMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_PREFIX(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.prefix_code;
        },
        AFFTER_DELETED_PREFIX(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
